angular
    .module('userNotifications.v1')
    .directive('needsPrintFilesList', needsPrintFilesList)
    .directive('needsPrintFilesListItemWrapper', needsPrintFilesListItemWrapper)
    .directive('needsPrintFilesListItem', needsPrintFilesListItem);

/**
 * @ngdoc directive
 * @name userNotifications.v1.directive:needsPrintFilesList
 * @restrict A
 * @element any
 *
 * @description
 * Displays a list of all jobs marked as "needs print files," and exposes notification
 * data to the theme markup.
 *
 * **Requirements:** A `needs-print-files-list-item` element must be a child of this element. See example.
 *
 * #### Data
 * - `{{orderNumber}}` : the order number each notification is associated with
 * - `{{jobNumber}}` : the job number each notification is associated with
 * - `{{jobName}}` : the name of the associated job
 * - `{{jobHref}}` : the href of the associated job
 * - `{{productName}}` : the product name of the associated job
 *
 * #### Script file
 * - `/web3/build/storefront/widgets/needs-print-files-list.v1.directive.js`
 *
 * #### Classes
 * - `isPending` : applied while notifications are in the proces of loading
 * - `isEmpty` : applied when there are 0 notifications in the list
 *
 * #### Events
 * - `window.events.NEEDS_PRINT_FILES_LIST_UPDATED` : raised whenever the notification list changes
 *
 * @example
    <pre>
        <!-- load widget script -->
        <script src="/web3/build/storefront/widgets/needs-print-files-list.v1.directive.js"></script>

        <!-- display widget -->
        <div needs-print-files-list>
            <div needs-print-files-list-item>
                <p>Order Number: {{orderNumber}}</p>
                <p>Job Number: {{jobNumber}}</p>
                <p>Job Name: {{jobName}}</p>
                <p>Job Link: {{jobHref}}</p>
                <p>Product Name: {{productName}}</p>
            </div>
        </div>

        <!-- respond to events -->
        <script>
            window.events.listen(window.events.NEEDS_PRINT_FILES_LIST_UPDATED, function () {
                console.log('needs print files list updated');
            });
        </script>
    </pre>
    *
    * #### Output markup:
    * - This directive adds an unordered list between the `needs-print-files-list` element and the
    * `needs-print-files-list-item` elements.
    *
    * ```
    *       <div needs-print-files-list>
    *           <ul class="notificationList notificationList_needsPrintFiles">
    *               <li class="notificationList-item">
    *                   <div needs-print-files-list-item>
    *                       ...
    *                   </div>
    *               </li>
    *               ...
    *           </ul
    *       </div>
    * ```
    *
    */


needsPrintFilesList.$inject = [];

function needsPrintFilesList () {
    return {
        restrict: 'A',
        transclude: true,
        template: '<ul class="notificationList notificationList_needsPrintFiles"><li class="notificationList-item" ng-repeat="notification in needsPrintFilesListController.notifications"><div needs-print-files-list-item-wrapper="notification" class="notificationList-item-wrapper"><ng-transclude /></div></li></ul>',
        link: function pendingReviewListDirective_linkFn (scope, element, attrs, controller, transclude) {},
        controller: NeedsPrintFilesListController,
        controllerAs: 'needsPrintFilesListController',
        bindToController: true,
        scope: {}
    };
};

NeedsPrintFilesListController.$inject = ['$scope', '$element', 'userNotificationsService', 'authService', '$timeout'];

function NeedsPrintFilesListController ($scope, $element, userNotificationsService, authService, $timeout) {
    var vm = this;

    vm.notifications = [];

    init();

    return;

    function init () {
        $element
            .addClass('isEmpty')
            .addClass('isPending');
        // Subscribe to auth changes
        authService.subscribe($scope, handleAuthChange);
        // Subscribe to needsPrintFilesItems updates
        userNotificationsService.needsPrintFilesItems.subscribe($scope, handleNeedsPrintFilesItemsUpdate);
        // Subscribe to classic events
        userNotificationsService.classicEvents.subscribe($scope, getNeedsPrintFilesCount);
        // Initial loading of needsPrintFilesItems
        getNeedsPrintFilesCount();
    }

    function handleAuthChange ($event, user) {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        getNeedsPrintFilesCount();
    }

    function getNeedsPrintFilesCount () {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        userNotificationsService.needsPrintFilesItems.get(authService.getUser().id);
    }

    function handleNeedsPrintFilesItemsUpdate ($event, notifications) {
        if (!notifications) {
            return resetDirective();
        }

        if (!notifications.length) {
            $element.addClass('isEmpty');
        } else {
            $element.removeClass('isEmpty');
        }

        $timeout(function(){
            vm.notifications = notifications;
        });
        $element
            .show()
            .removeClass('isPending');
    }

    function resetDirective () {
        vm.notifications = [];
        $element
            .hide()
            .addClass('isEmpty')
            .removeClass('isPending');
    }
};


needsPrintFilesListItemWrapper.$inject = [];

function needsPrintFilesListItemWrapper () {
    return {
        restrict: 'A',
        transclude: true,
        template: '<ng-transclude />',
        link: function needsPrintFilesListItemWrapperDirective_linkFn (scope, element, attrs, controller, transclude) {},
        controller: NeedsPrintFilesListItemWrapperController,
        controllerAs: 'needsPrintFilesListItemWrapperController',
        bindToController: true,
        scope: {
            notification: '<needsPrintFilesListItemWrapper'
        }
    };
};

NeedsPrintFilesListItemWrapperController.$inject = [];

function NeedsPrintFilesListItemWrapperController () {};


needsPrintFilesListItem.$inject = [];

function needsPrintFilesListItem () {
    return {
        restrict: 'A',
        require: '^needsPrintFilesListItemWrapper',
        transclude: true,
        template: '<a href="{{jobHref}}" rel="nofollow"><p class="order-number">Order #<span>{{orderNumber}}</span></p><p class="item-number">Item #<span>{{jobNumber}}</span></p><p class="item-name">{{jobName}}</p></a>',
        link: function needsPrintFilesItemDirective_linkFn (scope, element, attrs, needsPrintFilesListItemWrapperController, transclude) {
            scope.orderNumber = needsPrintFilesListItemWrapperController.notification.orderNumber;
            scope.jobNumber = needsPrintFilesListItemWrapperController.notification.jobNumber;
            scope.jobName = needsPrintFilesListItemWrapperController.notification.jobName;
            scope.jobHref = needsPrintFilesListItemWrapperController.notification.jobStorefrontLink;
            scope.productName = needsPrintFilesListItemWrapperController.notification.productName;
        }
    };
};